import { useState } from "react";
import { Copy } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/Button";

/** Copyable request block (curl example) used by the Workflow API views. */
export function CopyableRequest({
  value,
  testId,
}: {
  value: string;
  testId?: string;
}) {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);
  return (
    <div className="relative" data-testid={testId}>
      <pre className="max-h-96 overflow-auto rounded-xl bg-muted p-4 pr-12 font-mono text-xs text-foreground">
        {value}
      </pre>
      <Button
        variant="secondary"
        size="icon"
        className="absolute right-2 top-2"
        aria-label={t("agentSpec.copyApiRequest")}
        onClick={() => {
          void navigator.clipboard.writeText(value).then(() => {
            setCopied(true);
            window.setTimeout(() => setCopied(false), 1500);
          });
        }}
      >
        <Copy className="h-4 w-4" />
      </Button>
      <span className="sr-only" aria-live="polite">
        {copied ? t("agentSpec.apiRequestCopied") : ""}
      </span>
    </div>
  );
}
